import { useState } from "react";
import { STATIC_STRINGS } from "@asez/shared";
import {
  updateExperience,
  updateSkills,
} from "../../../../../store/steps/stepOneSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { GenericAutocomplete } from "@asez/component-library";
import Slider from "@mui/material/Slider";
import AskAiModal from "./AskAiModal";

const ExperienceSkills = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(false);

  const experience = useSelector(
    (state: RootState) => state.stepOne.experience
  );
  const skills = useSelector((state: RootState) => state.stepOne.skills);

  return (
    <>
      <div className="w-2/5 mx-auto flex flex-col justify-start">
        <div className="flex flex-col py-2">
          <div className="flex justify-between items-center pb-2 font-medium">
            <div>{STATIC_STRINGS.EXPERIENCE_RANGE}</div>
            <div>{`${experience[0]} - ${experience[1]} Years`}</div>
          </div>
          <div className="h-14 flex items-center">
            <Slider
              value={experience}
              min={0}
              max={15}
              onChange={(e, newValue) =>
                dispatch(updateExperience(newValue as number[]))
              }
              sx={{ color: "var(--color-neutral-dark)" }}
              valueLabelDisplay="auto"
            />
          </div>
        </div>
        <div className="flex flex-col py-2">
          <div className="flex justify-between items-center pb-2">
            <div className="font-medium capitalize text-nowrap mr-2">
              {STATIC_STRINGS.SKILLS_TITLE}
            </div>
            <button
              onClick={() => setOpen(true)}
              className="cursor-pointer text-neutral-dark px-1 font-medium xl:text-base border-transparent border-b-2 hover:border-neutral-dark transition-all capitalize text-nowrap"
            >
              {STATIC_STRINGS.TAKE_AI_HELP}
            </button>
          </div>
          <GenericAutocomplete
            options={[]}
            freeSolo={true}
            value={skills}
            onChangeHandler={(e, newValue) => dispatch(updateSkills(newValue))}
            placeholder={STATIC_STRINGS.SKILLS_PLACEHOLDER}
          />
        </div>
      </div>
      <AskAiModal open={open} setOpen={setOpen} />
    </>
  );
};

export default ExperienceSkills;
